import type { TableSemanticSchema } from './types';

export const RetroSchema: TableSemanticSchema = {
  id: 'retro',
  name: 'Retrospective Board',
  description:
    'Four Ls retrospective with voting and action-item escalation. Action items link forward to the Gantt/kanban task they generate.',
  cells: [
    { id: 'liked', label: 'Liked', row: 0, col: 0, accent: '#16a34a' },
    { id: 'learned', label: 'Learned', row: 0, col: 1, accent: '#2563eb' },
    { id: 'lacked', label: 'Lacked', row: 1, col: 0, accent: '#f59e0b' },
    { id: 'longed_for', label: 'Longed For', row: 1, col: 1, accent: '#9333ea' },
  ],
  itemFields: [
    { key: 'category', label: 'Category', kind: 'enum', required: true,
      options: [
        { value: 'liked', label: 'Liked' },
        { value: 'learned', label: 'Learned' },
        { value: 'lacked', label: 'Lacked' },
        { value: 'longed_for', label: 'Longed For' },
      ] },
    { key: 'votes', label: 'Votes', kind: 'number' },
    { key: 'actionItem', label: 'Action Item', kind: 'string' },
    { key: 'owner', label: 'Owner', kind: 'string' },
    { key: 'linkedTask', label: 'Linked Task', kind: 'id',
      description: 'Cross-link to a Gantt or kanban task when the retro generates one.' },
  ],
  renderingHints: {
    layout: 'quadrant',
    voting: true,
  },
};
